import React from 'react';
import { Instagram } from 'lucide-react';
export function Footer() {
  return <footer className="bg-white py-12 border-t border-cream" data-id="element-157">
      <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-158">
        <div className="text-center md:text-left flex items-center gap-3" data-id="element-159">
          <img src="https://cdn.magicpatterns.com/uploads/kpVrCPSWuXAnViG1Cefqkt/180CEA11-01BE-46F5-A413-75D2EEDF1DE4.jpg" alt="Nicole Cabello" className="w-10 h-10 rounded-full object-cover border-2 border-rosegold/30" data-id="element-160" />
          <span className="text-sm text-taupe" data-id="element-161">Impulsadora de Mujeres</span>
        </div>

        <div className="flex space-x-6" data-id="element-162">
          <a href="https://www.instagram.com/impulsadorademujeres" target="_blank" rel="noopener noreferrer" className="text-taupe hover:text-rosegold transition-colors" data-id="element-163">
            <Instagram size={24} data-id="element-164" />
          </a>
        </div>

        <div className="text-sm text-taupe/70 flex flex-col md:flex-row items-center gap-4" data-id="element-165">
          <span data-id="element-166">
            © 2026 Impulsadora de mujeres. Todos los derechos reservados.
          </span>
          <div className="flex gap-4" data-id="element-167">
            <a href="#" className="hover:text-taupe transition-colors" data-id="element-168">
              Política de Privacidad
            </a>
            <a href="#" className="hover:text-taupe transition-colors" data-id="element-169">
              Términos y Condiciones
            </a>
          </div>
        </div>
      </div>
    </footer>;
}